import { computed } from "vue";
import useVuelidate from "@vuelidate/core";
import { getValidationRules } from "../utils/validation/index.mjs";
export function useFormValidation(formData, formValues) {
  const validationRules = computed(() => {
    const rules = {};
    for (const step of formData.steps) {
      for (const field of step.fields) {
        const fieldRules = getValidationRules(field);
        if (Object.keys(fieldRules).length > 0) {
          rules[field.name] = { ...fieldRules, $autoDirty: true, $lazy: true };
        }
      }
    }
    return rules;
  });
  const $v = useVuelidate(validationRules, formValues);
  const stepsValidationState = computed(() => {
    return formData.steps.map((step) => {
      const stepFields = step.fields;
      const isStepValid = stepFields.every((field) => {
        const fieldValidation = $v.value[field.name];
        if (!fieldValidation)
          return true;
        return !fieldValidation.$invalid;
      });
      return isStepValid;
    });
  });
  const validateStep = async (stepIndex) => {
    const currentStep = formData.steps[stepIndex];
    const stepFieldNames = currentStep.fields.map((field) => field.name);
    const stepValidation = stepFieldNames.map((fieldName) => {
      if ($v.value[fieldName]) {
        return $v.value[fieldName].$validate();
      }
      return Promise.resolve(true);
    });
    const results = await Promise.all(stepValidation);
    return results.every((result) => result);
  };
  const validateAll = async () => {
    return await $v.value.$validate();
  };
  const getFieldError = (fieldName) => {
    const fieldValidation = $v.value[fieldName];
    if (!fieldValidation || !fieldValidation.$error) {
      return null;
    }
    const errors = fieldValidation.$errors;
    return errors.length > 0 ? errors[0].$message : null;
  };
  const hasFieldError = (fieldName) => {
    const fieldValidation = $v.value[fieldName];
    return fieldValidation ? fieldValidation.$error : false;
  };
  const resetValidation = () => {
    $v.value.$reset();
  };
  return {
    validateStep,
    validateAll,
    getFieldError,
    hasFieldError,
    resetValidation,
    stepsValidationState
  };
}
